<p-fieldset legend="Tools">
        <p-message severity="secondary"><p-button label="Add Tool" (onClick)="goToAddToolsPage()"/></p-message>  
    <p class="my-4">
        <p-iftalabel>
            <input pInputText autocomplete="off" fluid [formControl]="searchQuery"/> 
            <label>Search...</label>
        </p-iftalabel>   
        <small id="searchQuery-help">Use Tool name/Tool URL/ClientId to search (min. 3 characters)
        </small>
    </p>
    <p class="m-0">
                    <p-table selectionMode="single" 
                    [value]="tools" size="small" 
                    [loading]="loading()" stripedRows 
                    showGridlines [paginator]="true"  
                    [rows]="10" [tableStyle]="{ 'min-width': '50rem' }" 
                    [rowsPerPageOptions]="[5, 10]" 
                    [(selection)]="selectedTool" 
                    dataKey="clientId"
                    [lazy]="true" [totalRecords]="totalRecords()" 
                    (onLazyLoad)="onLazyLoad($event)"
                    [first]="first">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="name" style="width:11%">
                                    Name <p-sortIcon field="name"/>
                                </th>
                                <th style="width:11%">ClientId</th>
                                <th style="width:11%">Active</th>
                                <th style="width:11%">Supports Deeplinking</th>
                                <th style="width:11%">Grade Service</th>
                                <th style="width:11%">NRPS Service</th>
                                <th style="width:11%" pTooltip="Sharing learner email with 3rd Party Tool" tooltipPosition="top">Sharing Learner Email</th>
                                <th style="width:11%" pTooltip="Sharing learner full name with 3rd Party Tool" tooltipPosition="top">Sharing Learner Full Name</th>
                                <th style="width:11%">&nbsp;</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-tool>
                            <tr [pSelectableRow]="tool">
                                <td>{{ tool.name }}</td>
                                <td>{{ tool.clientId }}</td>
                                <td>
                                    @if (tool.isActive) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.supportsDeepLinking) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isAssignmentAndGradeServiceEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isNamesAndRoleProvisioningServiceEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isSharingEmailOfLearnerWithToolEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isSharingFullNameOfLearnerWithToolEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    <p-button icon="pi pi-info-circle" severity="contrast" size="small" (click)="showToolCredentials(tool)" styleClass="mr-2" pTooltip="View Tool Credentials" tooltipPosition="top" />&nbsp;
                                    <p-button icon="pi pi-pencil" severity="primary" size="small" (click)="editTool(tool)" styleClass="mr-2" pTooltip="Edit Tool Credentials" tooltipPosition="top" />&nbsp;
                                    <p-button icon="pi pi-trash" severity="danger" size="small" (click)="deleteTool(tool)" styleClass="mr-2" pTooltip="Delete Tool" tooltipPosition="top" />
                                    
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
</p-fieldset>

<p-dialog header="Tool Credentials" [modal]="true" [(visible)]="toolCredentialsDialogVisible" [style]="{ width: '65rem' }">
    @if (displayTool) {
        <ul class="tool-credentials-list">
            <li><strong>Name:</strong> {{ displayTool.name }}</li>
            <li><strong>Client ID:</strong> {{ displayTool.clientId }}</li>
            <li><strong>Deployment ID:</strong> {{ displayTool.deploymentId }}</li>
            <li><strong>Platform URL:</strong> {{ commonDetails.platformURL }}</li>
            <li><strong>Authentication URL:</strong> {{ commonDetails.authenticationURL }}</li>
            <li><strong>Access Token URL:</strong> {{ commonDetails.accessTokenURL }}</li>
            <li><strong>JWKS URL:</strong> {{ commonDetails.jwksURL }}</li>
        </ul>
        <div class="flex justify-end gap-2 mt-3">
            <p-button label="Copy" icon="pi pi-copy" severity="info" (click)="copyCredentialsToClipboard(displayTool)" />
            <p-button label="Close" severity="secondary" (click)="toolCredentialsDialogVisible = false" />
        </div>
    }
    
</p-dialog>

        